var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.313 16.125C14.2445 16.125 14.9996 15.3699 14.9996 14.4383V14.0068C14.9996 13.3361 14.7599 12.6874 14.3238 12.1779C13.1468 10.8028 11.3564 10.1241 8.99734 10.1241C6.63795 10.1241 4.84844 10.803 3.67371 12.1787C3.23889 12.6879 3 13.3355 3 14.0051V14.4383C3 15.3699 3.75514 16.125 4.68666 16.125H13.313ZM13.313 15H4.68666C4.37646 15 4.125 14.7485 4.125 14.4383V14.0051C4.125 13.6033 4.26833 13.2148 4.52923 12.9093C5.46921 11.8085 6.94362 11.2491 8.99734 11.2491C11.0511 11.2491 12.5268 11.8085 13.4691 12.9095C13.7308 13.2152 13.8746 13.6044 13.8746 14.0068V14.4383C13.8746 14.7485 13.6232 15 13.313 15Z",
    fill: "#222729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 106 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7.875C10.2426 7.875 11.25 6.86764 11.25 5.625C11.25 4.38236 10.2426 3.375 9 3.375C7.75736 3.375 6.75 4.38236 6.75 5.625C6.75 6.86764 7.75736 7.875 9 7.875ZM9 9C10.864 9 12.375 7.48896 12.375 5.625C12.375 3.76104 10.864 2.25 9 2.25C7.13604 2.25 5.625 3.76104 5.625 5.625C5.625 7.48896 7.13604 9 9 9Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyPage);
export default __webpack_public_path__ + "static/media/icon-my-page.8126115aefc6d4cb34d8c6921ccfa8e9.svg";
export { ForwardRef as ReactComponent };